import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import InternalCreditureTable from './InternalCreditureTable';
import ExternalCreditureTable from './ExternalCreditureTable';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllExternCrediteurAsync, getAllInternCrediteurAsync, updateCreditorToPreferenceAsync } from '@application/features/creditures/creditureThunk';
import VnPagination from '@ui/components/VnPagination';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const Crediture = () => {
    VnDocumentTitle('Visser Leveranciers');
    const [activeTab, setActiveTab] = useState('InternalCrediture');
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { internCreditures, internCreditureRequest, externCreditureRequest, externCreditures } = useAppSelector((state) => state.crediture);
    const [internCreditureText, setInternCreditureText] = useState('');
    const [externCreditureText, setExternCreditureText] = useState('');
    const defaultSortingCriteria = {
        sortColumnKey: 'creditorNumber',
        sortDirection: 'desc'
    };
    // const [internalFilterValues, setInternalFilterValues] = useState<CreditorFilterDto>({
    //     pageNumber: 1,
    //     pageSize: 30,
    //     sortColumnKey: defaultSortingCriteria.sortColumnKey,
    //     sortDirection: defaultSortingCriteria.sortDirection,
    //     creditorNumber: null,
    //     name: null,
    //     keywords: null,
    //     address: null,
    //     postalCode: null,
    //     city: null,
    //     country: null,
    //     phoneNumber: null,
    //     fax: null,
    //     preference: null
    // });
    // const [externalFilterValues, setExternalFilterValues] = useState<CreditorFilterDto>({
    //     pageNumber: 1,
    //     pageSize: 30,
    //     sortColumnKey: defaultSortingCriteria.sortColumnKey,
    //     sortDirection: defaultSortingCriteria.sortDirection,
    //     creditorNumber: null,
    //     name: null,
    //     keywords: null,
    //     address: null,
    //     postalCode: null,
    //     city: null,
    //     country: null,
    //     phoneNumber: null,
    //     fax: null,
    //     preference: null
    // });
    const defaultInternalFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        creditorNumber: null,
        name: null,
        keywords: null,
        address: null,
        postalCode: null,
        city: null,
        country: null,
        phoneNumber: null,
        fax: null,
        preference: null
    };
    const defaultExternalFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        creditorNumber: null,
        name: null,
        keywords: null,
        address: null,
        postalCode: null,
        city: null,
        country: null,
        phoneNumber: null,
        fax: null,
        preference: null
    };
    const [internalFilterValues, setInternalFilterValues] = useState(defaultInternalFilterValues);
    const [externalFilterValues, setExternalFilterValues] = useState(defaultExternalFilterValues);
    const handleAddSupplierClick = () => {
        navigate(`/admin/CreditureTabs`);
    };
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    const onRowClick = (rowId) => {
        window.open(`/admin/CreditureTabs/${rowId}`, '_blank');
    };
    /*Internal Grid Part*/
    const updateInternalFilterValues = (newValues) => {
        setInternalFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchInternCreditureHandler(searchText) {
        updateInternalFilterValues({ filter: searchText });
        dispatch(getAllInternCrediteurAsync({ ...internalFilterValues, filter: searchText, pageNumber: 1 }));
    }
    function onInternalCredituresPageChange(pageNumber) {
        updateInternalFilterValues({ pageNumber });
        dispatch(getAllInternCrediteurAsync({ ...internalFilterValues, pageNumber }));
    }
    function InternalSortingHandler(data) {
        updateInternalFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllInternCrediteurAsync({
            ...internalFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function InternalFilteringHandler(data) {
        data.pageNumber = 1;
        updateInternalFilterValues(data);
        dispatch(getAllInternCrediteurAsync({
            ...internalFilterValues,
            ...data
        }));
    }
    useEffect(() => {
        if (activeTab === 'InternalCrediture') {
            setInternalFilterValues(defaultInternalFilterValues);
            dispatch(getAllInternCrediteurAsync(defaultInternalFilterValues));
        }
        else if (activeTab === 'ExternalCrediture') {
            setExternalFilterValues(defaultExternalFilterValues);
            dispatch(getAllExternCrediteurAsync(defaultExternalFilterValues));
        }
    }, [activeTab, dispatch, internCreditureRequest, externCreditureRequest]);
    /*External Grid Part*/
    const updateExternalFilterValues = (newValues) => {
        setExternalFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchExternCreditureHandler(searchText) {
        updateExternalFilterValues({ filter: searchText });
        dispatch(getAllExternCrediteurAsync({ ...externalFilterValues, filter: searchText, pageNumber: 1 }));
    }
    function onExternCredituresPageChange(pageNumber) {
        updateExternalFilterValues({ pageNumber });
        dispatch(getAllExternCrediteurAsync({ ...externalFilterValues, pageNumber }));
    }
    function ExternalSortingHandler(data) {
        updateExternalFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllExternCrediteurAsync({
            ...externalFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function ExternalFilteringHandler(data) {
        data.pageNumber = 1;
        updateExternalFilterValues(data);
        dispatch(getAllExternCrediteurAsync({
            ...externalFilterValues,
            ...data
        }));
    }
    const handleInternalPreferenceToggleButtonClick = (creditorId, preference) => {
        const preferenceDto = {
            id: creditorId,
            Preference: preference
        };
        dispatch(updateCreditorToPreferenceAsync(preferenceDto))
            .unwrap()
            .then((res) => {
            dispatch(getAllInternCrediteurAsync(internalFilterValues));
        });
    };
    const handleExternalPreferenceToggleButtonClick = (creditorId, preference) => {
        const preferenceDto = {
            id: creditorId,
            Preference: preference
        };
        dispatch(updateCreditorToPreferenceAsync(preferenceDto))
            .unwrap()
            .then((res) => {
            dispatch(getAllExternCrediteurAsync(externalFilterValues));
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                }, children: [_jsx("h4", { children: "Leveranciers" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Leverancier', onClick: handleAddSupplierClick, isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Create) }) })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InternalCrediture', title: 'Interne Leveranciers' }), _jsx(Tab, { eventKey: 'ExternalCrediture', title: 'Externe Leveranciers' })] }), _jsxs("div", { className: 'mt-0', children: [activeTab === 'InternalCrediture' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchInternCreditureHandler }), _jsx(InternalCreditureTable, { creditures: internCreditures?.items, onRowClick: onRowClick, onSorting: InternalSortingHandler, onFilter: InternalFilteringHandler, defaultSortingCriteria: defaultSortingCriteria, onPreferenceToggleUpdate: handleInternalPreferenceToggleButtonClick }), _jsx("div", { className: 'mt-3', children: internCreditures && (_jsx(VnPagination, { currentPage: internCreditures?.pageNumber, totalPages: internCreditures?.totalPages, onPageChange: onInternalCredituresPageChange })) })] })), activeTab === 'ExternalCrediture' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchExternCreditureHandler }), _jsx(ExternalCreditureTable, { creditures: externCreditures?.items, onRowClick: onRowClick, onSorting: ExternalSortingHandler, onFilter: ExternalFilteringHandler, defaultSortingCriteria: defaultSortingCriteria, onPreferenceToggleUpdate: handleExternalPreferenceToggleButtonClick }), _jsx("div", { className: 'mt-3', children: externCreditures && (_jsx(VnPagination, { currentPage: externCreditures?.pageNumber, totalPages: externCreditures?.totalPages, onPageChange: onExternCredituresPageChange })) })] }))] })] }));
};
export default Crediture;
